import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';

interface ArrowProps {
  open: boolean;
}

export function Arrow(props: ArrowProps) {
  return props.open ? <ArrowDropUp fontSize="small" /> : <ArrowDropDown fontSize="small" />;
}
